export const DEFAULT_EMPTY_MESSAGE = 'No data found.';
export const DEFAULT_LOADING_MESSAGE = 'Loading...';
export const DEFAULT_TABLE_TITLE = 'Table';
export const DEFAULT_COLUMN_WIDTH = 'w-[15%]';
